// extracted by mini-css-extract-plugin
export var csatScore = "_nd-5";
export var header = "_nd-1";
export var panelWrapper = "_nd-2";
export var postPreview = "_nd-3";
export var rightContent = "_nd-0";
export var wrappingText = "_nd-4";